import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { ErrorLogModule } from '@/store/modules/error-log';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialogTableVisible = false;
  }
  get errorLogs() {
    return ErrorLogModule.logs;
  }
  clearAll() {
    this.dialogTableVisible = false;
    ErrorLogModule.ClearErrorLog();
  }
};
default_1 = __decorate([Component({
  name: 'ErrorLog'
})], default_1);
export default default_1;